import css from "standard/css";

const style = css`
  .feedback {
    align-items: center;
    border: 1px solid #C9C9C9;
    border-radius: var(--border-radius-md);
    display: flex;
    gap: var(--spacing_inset-xs);
    padding: var(--spacing-nano);
    width: fit-content;
  }

  .feedback__button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 42px;
    position: relative;
    width: 42px;
  }

  .feedback__separator {
    background-color: #C9C9C9;
    height: 35px;
    width: 1px;
  }

  .feedback__button::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    height: 42px;
    top: 0;
    width: 42px;
  }

  .feedback__button svg {
    color: #fff;
  }

  .feedback__button:hover {
    transform: translateY(-1px);
  }

  .feedback button[selected="true"]:nth-of-type(1) svg {
    color: #FB601D;
    transition: transform 0.5s ease;
  }

  .feedback button[selected="true"]:nth-of-type(2) svg {
    color: #FB601D;
  }

  .feedback button[selected="true"]:nth-of-type(3) svg {
    color: #FB601D;
  }
`;

export default style;
